import styled, { css } from 'styled-components';

interface ThumbsContainerProps {
  feedbackSent: boolean;
}

export const ChatThreadContainer = styled.div`
  flex: 1;
  overflow-y: scroll;
  padding: 16px 100px;
  border-radius: 5px;
`;

export const ChatThreadBgBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ChatThreadPlaceHolderBox = styled.div`
  width: 100%;
  overflow-y: scroll;
  padding: 20px 0 30px;
  margin-top: 200px;
  min-width: 1170px;
`;

export const ChatThreadPlaceHolderIconContainer = styled.div`
  margin-bottom: 12px;

  svg {
    width: 24px;
    height: 24px;
    display: block;
  }
`;

export const ChatThreadPlaceHolderContainer = styled.div`
  width: 1170px;
  display: flex;
  justify-content: space-between;
  margin: auto;
`;

export const ChatThreadPlaceHolderColumn = styled.div`
  width: 280px;

  img {
    display: block;
    margin: auto;
  }
`;

export const LoadingText = styled.span`
  font-size: 12px;
  color: #000;
  display: inline-block;
  padding-left: 8px;
  position: relative;
  top: 1px;
`;

export const LoadingContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const ChatThreadPlaceHolderQuestionItem = styled.div`
  font-size: 16px;
  color: #4c4c4c;
  padding: 16px;
  height: 100%;
  border-radius: 6px;
  border: 1px solid rgb(0 0 0 / 15%);
  box-shadow: 2px 6px 10px 0 rgb(0 0 0 / 20%);
  background-color: #fff;
  cursor: pointer;

  &:hover {
    background-color: rgb(0 0 0 / 1%);
  }
`;

export const ChatFeed = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const UserChatContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const UserChatMessage = styled.h3`
  color: #1f1f1f;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
`;

export const BotChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #000;
  border-radius: 5px 5px 5px 0;
  margin: 20px 0 0;
`;

export const BotMsgSection = styled.div`
  display: block;
`;

export const BotChatMessage = styled.p`
  width: 100%;
  word-wrap: break-word;
  margin: 0;
  font-size: 16px;
`;

export const BotMsgOptions = styled.div`
  display: flex;
  margin: 12px;

  svg {
    font-size: 14px;
    cursor: pointer;
  }

  svg:hover {
    transform: scale(1.1);
    transition: all 0.1s ease-in-out;
  }
`;

export const BotMsgError = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  h4 {
    margin-top: 10px;
  }
`;

export const BotChatFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const NextQuestionContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CONTAINER_WIDTH = 725;

export const NextQuestionContentContainer = styled.div`
  display: inline-block;
  width: 100%;
  overflow: auto;
  white-space: nowrap;
  padding: 10px 0 14px;
`;

export const NextQuestionContentAll = styled.div`
  display: inline-block;
  white-space: nowrap;
`;

export const NextQuestionItem = styled.div`
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);
  border: 1px solid #eee;
  margin-right: 8px;
  display: inline-block;
  border-radius: 8px;
  background: #fff;
  padding: 6px 10px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #4d7eff;
  }

  &.asked {
    cursor: not-allowed;
    background: #dcdcdc;
    color: #a3a3a3;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const CheckboxGroupContainer = styled.div`
  margin-bottom: 16px;

  label {
    margin: 8px 0;
  }
`;

export const TextAreaBox = styled.div`
  margin-bottom: 16px;
`;

export const ThumbsContainer = styled.div<ThumbsContainerProps>`
  display: flex;
  font-size: 24px;

  svg {
    margin: 0 4px;
    cursor: pointer;
    font-size: 14px;
  }

  ${(props) =>
    props.feedbackSent
      ? css`
          svg:hover {
            cursor: not-allowed;
          }
        `
      : css`
          svg:hover {
            transform: scale(1.1);
            transition: all 0.1s ease-in-out;
          }
        `}
`;

export const ChatSep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px 0;
  width: 100%;

  hr {
    display: block;
    height: 1px;
    width: 100%;
    border: 0;
    padding: 0;
    background: #eee;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  label {
    margin-inline-start: 0 !important;
  }
`;

export const MetricName = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #000;
  display: flex;
  align-items: center;
`;

export const FeedItem = styled.div`
  width: 100%;
`;

export const DimensionTableContainer = styled.div`
  display: block;
  width: 60%;
  border: 1px solid #eee;

  .ant-table-thead .ant-table-cell {
    background-color: #f1f4ff;
  }
`;

export const DimensionName = styled.div`
  color: #1e1e1e;
  font-size: 16px;
  font-weight: bold;
  padding: 16px;
`;

export const FeedbackContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin-top: 16px;
`;

export const CopyAndFeedback = styled.div`
  display: flex;
  align-items: center;
`;

export const DimensionTableTimeInterval = styled.span`
  display: inline-block;
  font-weight: normal;
  margin-left: 10px;
`;
